import React from 'react'
import AppBarMain from './AppBarMain'
import { Outlet } from "react-router-dom";

const PageOutlet = () => {
  return (
    <div>
       <AppBarMain
        isUserLoggedIn={true}
        isLeftNavBar={true}
        children={<Outlet />}/> 
    </div>
  )
}

export default PageOutlet